import { PwaInstallSheet } from "@frontend/components/pwa/PwaInstallSheet";
import { usePwaInstall } from "@frontend/hooks/usePwaInstall";
import { createContext, type ReactNode, useContext } from "react";

/**
 * Shares one `usePwaInstall` state across the tree, so the sheet, the
 * notification banner and the profile toggle read the same
 * install-available / standalone / apple-mobile answer and call the same
 * `install()`.
 */

type PwaInstallCtx = ReturnType<typeof usePwaInstall>;
const Ctx = createContext<PwaInstallCtx | null>(null);

export const PwaInstallHost = ({ children }: { children: ReactNode }) => {
	const state = usePwaInstall();
	return (
		<Ctx.Provider value={state}>
			{children}
			<PwaInstallSheet />
		</Ctx.Provider>
	);
};

export const usePwaInstallCtx = () => {
	const ctx = useContext(Ctx);
	if (!ctx) {
		throw new Error("usePwaInstallCtx must be used inside <PwaInstallHost>");
	}
	return ctx;
};
